import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { formatCurrency } from "@/lib/currencyFormatter";
import { MenuItem } from "@/types/menu";
import { useTranslation } from "react-i18next";

interface MenuItemDetailsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  item: MenuItem | null;
  onAddToCart: (item: MenuItem) => void;
}

export function MenuItemDetailsDialog({
  open,
  onOpenChange,
  item,
  onAddToCart,
}: MenuItemDetailsDialogProps) {
  const { t } = useTranslation();

  if (!item) return null;

  // Handle add to cart by dispatching a custom event
  const handleAddToCart = () => {
    const event = new CustomEvent("add-to-cart", { detail: item });
    window.dispatchEvent(event);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{item.name}</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          {item.image_url && (
            <div className="aspect-video overflow-hidden rounded-lg">
              <img
                src={item.image_url}
                alt={item.name}
                className="w-full h-full object-cover"
              />
            </div>
          )}

          <div>
            <p className="text-sm text-muted-foreground mb-2">
              {t("description")}
            </p>
            <p className="text-sm">{item.description || t("noDescription")}</p>
          </div>

          <div className="flex items-center justify-between pt-4 border-t">
            <span className="text-2xl font-bold">
              {formatCurrency(
                typeof item.price === "string"
                  ? parseFloat(item.price)
                  : item.price
              )}
            </span>
            <Button onClick={handleAddToCart} size="lg">
              {t("addToCart")}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
